// extracted by mini-css-extract-plugin
export default {"loading-icon":"Button_loading-icon__jAc-r","spin":"Button_spin__WCcNF"};